import React from 'react';
import PropTypes from 'prop-types';
import Input from '../input';

const InputBirthdate = ({
  disabled,
  value,
  setValue,
  errorText,
  showError,
  placeholderDay,
  placeholderMonth,
  placeholderYear,
  notShowLabel,
}) => {
  const handleOnChange = (name, text) => {
    setValue({
      ...value,
      [name]: text.replace(/\D/, ''),
    });
    switch (name) {
      case 'day':
        if (text.length === 2 || Number(text) >= 4) {
          const element = document.getElementById('inputMonth');
          setTimeout(() => element.focus(), 250);
        }
        break;
      case 'month':
        if (text.length === 2 || Number(text) >= 2) {
          const element = document.getElementById('inputYear');
          setTimeout(() => element.focus(), 250);
        }
        break;
      default:
    }
  };

  const handleBlur = (name) => {
    const format = Number(value[name]) < 10 && value[name].length === 1
      ? `0${value[name]}`
      : value[name];

    setValue({
      ...value,
      [name]: format,
    });
  };

  return (
    <div className="input-birthdate">
      <div className="input-birthdate-wrapper">
        <div className="input-day">
          <Input
            type="text"
            label={!notShowLabel ? 'Día' : ''}
            maxLength={2}
            value={value.day}
            onChange={(text) => handleOnChange('day', text)}
            onBlur={() => handleBlur('day')}
            disabled={disabled}
            placeholder={placeholderDay}
          />
        </div>

        <div className="input-month">
          <Input
            id="inputMonth"
            type="text"
            label={!notShowLabel ? 'Mes' : ''}
            maxLength={2}
            value={value.month}
            onChange={(text) => handleOnChange('month', text)}
            onBlur={() => handleBlur('month')}
            disabled={disabled}
            placeholder={placeholderMonth}
          />
        </div>

        <div className="input-year">
          <Input
            id="inputYear"
            type="text"
            label={!notShowLabel ? 'Año' : ''}
            maxLength={4}
            value={value.year}
            onChange={(text) => handleOnChange('year', text)}
            disabled={disabled}
            placeholder={placeholderYear}
          />
        </div>
      </div>
      {showError && (
        <div className="input-birthdate-error">
          {errorText}
        </div>
      )}
    </div>
  );
};

InputBirthdate.defaultProps = {
  disabled: false,
  errorText: '',
  showError: false,
  placeholderDay: '',
  placeholderMonth: '',
  placeholderYear: '',
  notShowLabel: false,
};

InputBirthdate.propTypes = {
  disabled: PropTypes.bool,
  placeholderDay: PropTypes.string,
  placeholderMonth: PropTypes.string,
  placeholderYear: PropTypes.string,
  notShowLabel: PropTypes.bool,
  value: PropTypes.shape({
    day: PropTypes.string,
    month: PropTypes.string,
    year: PropTypes.string,
  }).isRequired,
  setValue: PropTypes.func.isRequired,
  errorText: PropTypes.string,
  showError: PropTypes.bool,
};

export default InputBirthdate;
